import React from 'react';
import './MissionPillarsSection.css';

const MissionPillarsSection = () => {
  return (
    <section className="df-mission-section">
      <div className="df-mission-container">
        {/* Cabecera: Texto y Composición Ilustrada CFDI */}
        <div className="df-mission-header">
          <div className="df-mission-header-text">
            <span className="df-mission-tag">Nuestra misión</span>
            <h2 className="df-mission-title">
              Facilitar el intercambio de información y documentos electrónicos,{' '}
              <strong>garantizando su autenticidad e integridad</strong>.
            </h2>
          </div>

          {/* Gráfico decorativo de documentos CFDI */}
          <div className="df-mission-graphic" aria-hidden="true">
            {/* Círculo suave de fondo */}
            <div className="df-mission-circle-bg"></div>
            {/* Círculo con borde discontinuo */}
            <div className="df-mission-circle-dashed"></div>

            {/* Documento trasero inclinado */}
            <div className="df-mission-doc df-mission-doc-back">
              <div className="df-mission-doc-line df-mission-doc-line-dark"></div>
              <div className="df-mission-doc-line"></div>
              <div className="df-mission-doc-line"></div>
              <div className="df-mission-doc-line"></div>
            </div>

            {/* Documento frontal con badge CFDI */}
            <div className="df-mission-doc df-mission-doc-front">
              <span className="df-mission-doc-badge">CFDI</span>
              <div className="df-mission-doc-line"></div>
              <div className="df-mission-doc-line"></div>
              <div className="df-mission-doc-line"></div>
            </div>

            {/* Botón flotante de verificación / check */}
            <div className="df-mission-check-badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12.5l4.5 4.5L19 7.5"></path>
              </svg>
            </div>
          </div>
        </div>

        {/* Grilla de 3 Pilares (Con tarjeta central oscura idéntica a la muestra) */}
        <div className="df-mission-grid">
          {/* Pilar 1: Expertos en el campo */}
          <div className="df-mission-card">
            <div className="df-mission-icon-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="8" r="5"></circle>
                <path d="M8.5 12.5 7 22l5-3 5 3-1.5-9.5"></path>
              </svg>
            </div>
            <h3 className="df-mission-card-title">Expertos en el campo</h3>
            <p className="df-mission-card-desc">
              Nuestro equipo está compuesto por expertos con amplia experiencia. Nos mantenemos actualizados con las últimas tendencias y regulaciones para ofrecerte siempre un servicio de primera clase.
            </p>
          </div>

          {/* Pilar 2: Seguridad en primer lugar (Tarjeta Oscura Destacada) */}
          <div className="df-mission-card df-mission-card-dark">
            <div className="df-mission-icon-box df-mission-icon-box-primary">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3z"></path>
                <path d="m9 12 2 2 4-4"></path>
              </svg>
            </div>
            <h3 className="df-mission-card-title">Seguridad en primer lugar</h3>
            <p className="df-mission-card-desc">
              La seguridad es nuestra prioridad número uno. Utilizamos medidas de última generación y protocolos de seguridad robustos para proteger tus datos.
            </p>
          </div>

          {/* Pilar 3: Soluciones personalizadas */}
          <div className="df-mission-card">
            <div className="df-mission-icon-box">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 7h10M18 7h2M4 17h4M12 17h8"></path>
                <circle cx="16" cy="7" r="2"></circle>
                <circle cx="10" cy="17" r="2"></circle>
              </svg>
            </div>
            <h3 className="df-mission-card-title">Soluciones personalizadas</h3>
            <p className="df-mission-card-desc">
              Cada cliente es único: ofrecemos soluciones adaptadas a tus necesidades específicas. Desde pequeñas empresas hasta grandes corporaciones, te acompañamos en tu facturación y cumplimiento fiscal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionPillarsSection;
